// tslint:disable: no-host-metadata-property directive-selector
import { Directive, ElementRef, Input } from '@angular/core';
import {
  CdkCell,
  CdkCellDef,
  CdkColumnDef, CdkFooterCell, CdkFooterCellDef,
  CdkHeaderCell,
  CdkHeaderCellDef,
} from '@angular/cdk/table';

/**
 * Cell definition for the suka-table.
 * Captures the template of a column's data row cell as well as cell-specific properties.
 */
@Directive({
  selector: '[sukaCellDef]',
  providers: [{ provide: CdkCellDef, useExisting: SukaCellDef }]
})
export class SukaCellDef extends CdkCellDef { }

/**
 * Header cell definition for the suka-table.
 * Captures the template of a column's header cell and as well as cell-specific properties.
 */
@Directive({
  selector: '[sukaHeaderCellDef]',
  providers: [{ provide: CdkHeaderCellDef, useExisting: SukaHeaderCellDef }]
})
export class SukaHeaderCellDef extends CdkHeaderCellDef { }

/**
 * Footer cell definition for the suka-table.
 * Captures the template of a column's footer cell and as well as cell-specific properties.
 */
@Directive({
  selector: '[sukaFooterCellDef]',
  providers: [{ provide: CdkFooterCellDef, useExisting: SukaFooterCellDef }]
})
export class SukaFooterCellDef extends CdkFooterCellDef { }

/**
 * Column definition for the suka-table.
 * Defines a set of cells available for a table column.
 */
@Directive({
  selector: '[sukaColumnDef]',
  providers: [
    { provide: CdkColumnDef, useExisting: SukaColumnDef },
    { provide: 'SUKA_SORT_HEADER_COLUMN_DEF', useExisting: SukaColumnDef }
  ],
})
export class SukaColumnDef extends CdkColumnDef {
  /** Unique name for this column. */
  @Input('sukaColumnDef') name: string;

  /** Whether this column should be sticky positioned at the start of the row */
  @Input() sticky: boolean;

  /** Whether this column should be sticky positioned on the end of the row */
  @Input() stickyEnd: boolean;
}

/** Header cell template container that adds the right classes and role. */
@Directive({
  selector: 'suka-header-cell, th[suka-header-cell]',
  host: {
    class: 'suka-header-cell',
    role: 'columnheader',
  },
})
export class SukaHeaderCell extends CdkHeaderCell {
  constructor(
    columnDef: CdkColumnDef,
    elementRef: ElementRef<HTMLElement>
  ) {

    super(columnDef, elementRef);
    elementRef.nativeElement.classList.add(`suka-column-${columnDef.cssClassFriendlyName}`);
  }
}

/** Footer cell template container that adds the right classes and role. */
@Directive({
  selector: 'suka-footer-cell, td[suka-footer-cell]',
  host: {
    class: 'suka-footer-cell',
    role: 'gridcell',
  },
})
export class SukaFooterCell extends CdkFooterCell {
  constructor(
    columnDef: CdkColumnDef,
    elementRef: ElementRef
  ) {
    super(columnDef, elementRef);
    elementRef.nativeElement.classList.add(`suka-column-${columnDef.cssClassFriendlyName}`);
  }
}

/** Cell template container that adds the right classes and role. */
@Directive({
  selector: 'suka-cell, td[suka-cell]',
  host: {
    class: 'suka-cell',
    role: 'gridcell',
  },
})
export class SukaCell extends CdkCell {
  constructor(
    columnDef: CdkColumnDef,
    elementRef: ElementRef<HTMLElement>
  ) {
    super(columnDef, elementRef);
    elementRef.nativeElement.classList.add(`suka-column-${columnDef.cssClassFriendlyName}`);
  }
}
